import { resolveId } from '@medplum/core'
import type { Reference, ServiceRequest } from '@medplum/fhirtypes'
import { InboxItemType } from '@seen/core/models/inbox'
import { ExtendedPractitioner } from '@seen/core/models/practitioner'
import type { ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { ScrollArea } from '#src/components/core/scroll-area/ScrollArea.tsx'
import { OrderPage } from '#src/components/order/OrderPage.tsx'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'
import { useRead } from '#src/hooks/useRead.ts'
import { ResourceUnavailable } from '#src/pages/inbox/detail/ResourceUnavailable.tsx'
import { SidebarHeader } from '#src/pages/inbox/detail/SidebarHeader.tsx'

/* Order viewer */
export function OrderDetailView({
  orderRef,
  actionUrl,
  notificationItem,
  onClose,
}: {
  orderRef: Reference<ServiceRequest>
  actionUrl: string
  notificationItem: NotificationItem
  onClose: () => void
}): ReactNode {
  const orderId = resolveId(orderRef)
  const signerRef =
    notificationItem.data.type === InboxItemType.OrderSigned
      ? notificationItem.data.signedBy
      : undefined
  const { data: signer } = useRead(ExtendedPractitioner, signerRef)

  const title = signer ? `${signer.name} signed the order` : 'Order signed'

  return (
    <div className="flex h-full flex-col border-l border-border bg-background">
      <SidebarHeader
        title={title}
        actionUrl={actionUrl}
        actionLabel="Open chart"
        notificationItem={notificationItem}
        onClose={onClose}
      />
      <ScrollArea className="flex-1" scrollRestorationId="inbox-detail-order">
        <div className="p-4">
          <ErrorBoundary fallback={<ResourceUnavailable label="order" />}>
            <OrderPage orderId={orderId} hideMaximize />
          </ErrorBoundary>
        </div>
      </ScrollArea>
    </div>
  )
}
